import React from 'react'
import useLookupService from '../../../../services/lookup/useLookupService'

import * as designateReviewerTypes from './designateReviewerTypes'
import useTranslate from '../../../../i18n/useTranslate'

const useDesignateReviewer = (props: designateReviewerTypes.UseDesignateReviewerType) => {
    const { irb } = props
    const callLookup = useLookupService()
    const [reviewer, setReviewer] = React.useState<designateReviewerTypes.OptType[]>([])
    const translate = useTranslate()

    React.useEffect(() => {
        if (irb) {
            getReviewer()
        }
    }, [irb, translate.languageStore.currentLanguage])

    const getReviewer = async () => {
        if (irb) {
            const res = await callLookup.callReviewerLut(irb)
            const formatedData = res.result.map((itm) => {
                return {
                    label:
                        translate.languageStore.currentLanguage === translate.languageKey.th
                            ? itm.name_th
                            : itm.name_en,
                    value: `${itm.id}`,
                }
            })
            setReviewer(formatedData)
        }
    }

    return {
        reviewer,
    }
}

export default useDesignateReviewer
